import { Stack, Title, Text } from '@mantine/core';
import {
  SCOUT_IS_UNDER_MAINTENANCE,
  SCOUT_MAINTENANCE_DESCRIPTION,
  SCOUT_MAINTENANCE_TITLE,
} from '../scoutMaintenance';

interface ScoutChatEmptyStateProps {
  title?: string;
  description?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const ScoutChatEmptyState = ({
  title = SCOUT_IS_UNDER_MAINTENANCE
    ? SCOUT_MAINTENANCE_TITLE
    : 'How can Scout help?',
  description = SCOUT_IS_UNDER_MAINTENANCE
    ? SCOUT_MAINTENANCE_DESCRIPTION
    : 'Ask about matters, tasks, time entries, or anything in your workspace.',
  className,
  style,
}: ScoutChatEmptyStateProps) => {
  return (
    <Stack
      ta='center'
      gap='xs'
      p='lg'
      style={{
        minHeight: '100%',
        justifyContent: 'center',
        flex: 1,
        ...style,
      }}
      className={className}
    >
      <Title order={5}>{title}</Title>
      <Text c='dimmed'>{description}</Text>
    </Stack>
  );
};
